export const VOUCHER_REWARD_TYPE = {
  LOTTERY_TICKET: "LOTTERY_TICKET",
  SPINNING_WHEEL_TICKET: "SPINNING_WHEEL_TICKET",
} as const;
export type VOUCHER_REWARD_TYPE = (typeof VOUCHER_REWARD_TYPE)[keyof typeof VOUCHER_REWARD_TYPE];
